export const FRIENDS_TO_INVITE_FORM_KEY = 'friendsToInvite'
